import React from 'react';
import { getFinalURL } from '@bingads-webui-campaign-react/sdk-utils';
import { SDKNormalBlocker } from './normal-blocker';
import { SDKNoFinalUrlBlocker } from './no-final-url-blocker';

export const SDKWizardAnimationBlocker = () => {
  const hasFinalUrl = !!getFinalURL();

  return hasFinalUrl ? <SDKNormalBlocker /> : <SDKNoFinalUrlBlocker />;
};
export { SDKNormalBlocker };
